import styled from 'styled-components'

export const CascaderSwapper = styled.div<{
  infoHeight?: number
}>`
  width: 100%;
  position: relative;
  z-index: 9;
  box-sizing: border-box;

  .comp {
    height: 0;
    overflow: hidden;
    transition: all 0.5s ease;
  }
  .show {
    height: ${(props) => props.infoHeight * 40}px;
  }
`
export const ShowTokenInfo = styled.div`
  width: 98%;
  position: absolute;
  top: 42px;
  left: 1%;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
`
export const ShowTokenInfoItem = styled.div`
  height: 40px;
  line-height: 40px;
  background: #fff;
  padding: 0 10px;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    background: #f5f7fa;
  }
`
export const ShowInput = styled.div`
  height: 40px;
  width: 100%;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dfe4ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
`
